import * as Material from "@mui/material";

import "./styles.css";

import CloseIcon from "@mui/icons-material/Close";


const Box = {
  Title: ({ title }) => <h5 className="title px-2">{title}</h5>,

  

  Row: ({ children, baloon }) => {
    return (
      <div className={"box-row " + (baloon && "baloon-row")}>{children}</div>
    );
  },
  RowCloseButton: ({ onClick, tooltip = "" }) => (
    <Material.Tooltip arrow title={tooltip}>
      <Material.IconButton
        size="small"
        className="close-row-btn"
        variant="contained"
        onClick={onClick}
      >
        <CloseIcon fontSize="small" />
      </Material.IconButton>
    </Material.Tooltip>
  ),



  Container: ({ title, children }) => {
    return (
      <div className="box">
        <Box.Title title={title} />

        <Material.Divider flexItem />

        <div className="box-body px-2 py-1">{children}</div>
      </div>
    );
  },
};


export default Box